module.exports = __webpack_public_path__ + "static/media/dropdown_logo.5075ffc5.svg";